export function lerp(a: number, b: number, alpha: number): number {
  return a + alpha * (b - a)
}

const MOBILE_WIDTH = 428
const DESKTOP_WIDTH = 2500

// Returns 0
export function getScreenRatio(width): number {
  return Math.max(0, Math.min(1, (width - MOBILE_WIDTH) / (DESKTOP_WIDTH - MOBILE_WIDTH)))
}

export function getViewBoxEndpoints(width, params) {
  // Tween between mobile and desktop viewBox
  const ratio = getScreenRatio(width)
  const start = params.viewBoxMobile.start.map((s, i) =>
    lerp(s, params.viewBoxDesktop.start[i], ratio),
  )
  const end = params.viewBoxMobile.end.map((e, i) => lerp(e, params.viewBoxDesktop.end[i], ratio))
  return { start, end }
}

export function getViewBoxValues(percent, { start, end }) {
  // Tween based on scroll
  return start.map((s, i) => lerp(s, end[i], percent))
}

export function getViewBox(percent, { start, end }) {
  // Tween based on scroll
  return start.map((s, i) => lerp(s, end[i], percent)).join(' ')
}

/**
 * Calculate the minimum height of the map in px,
 * i.e. the height of the map when it is sticky.
 *
 * @param width
 */
export function calcMinHeight(innerWidth: number) {
  if (innerWidth < 428) {
    // For narrow screens we want the sticky map to maintain a
    // fixed aspect ratio (the aspect ratio of the end view box)
    return (innerWidth / 428) * 178
  } else {
    // For wider screens we scale between the height of mobile and desktop view box to find the height:
    return lerp(178, 227, getScreenRatio(innerWidth))
  }
}
